import type { RequestOptions } from "./AjaxController";

export const CLIENT_MUTATION_HEADER = "X-Client-Mutation-Id";

const DIRECT_SAVE_TIMEOUT_MS = 20_000;

export function clientMutationOptions(clientId?: string): RequestOptions | undefined {
  return clientId ? { headers: { [CLIENT_MUTATION_HEADER]: clientId }, timeoutMs: DIRECT_SAVE_TIMEOUT_MS } : undefined;
}
